import React from 'react';

import Container from './container';

const Chevron = ({ direction }) => {
  return <Container direction={direction}>❯</Container>;
};

export default Chevron;
